// extracted by mini-css-extract-plugin
export default {"w1180":"index_w1180_XcZ7g","mainBlock":"index_mainBlock_x6bq5","h2wrapper":"index_h2wrapper_djsTE","sideBar":"index_sideBar_O9WAY"};